// Page dictionary for insights/montel-energy-days-2026.html.
// English is the page's own HTML; main.js merges these over its shared dict.
window.FORSYT_PAGE_I18N = {
  fr: {
    "montel.hero_eyebrow": "Événement",
    "montel.hero_title":
      "Du volume à la valeur : croissance des EnR, prix capturés et opportunités pour les BESS",
    "montel.hero_date":
      'Publié le <time datetime="2026-10-01">1<sup>er</sup> octobre 2026</time>',
    "montel.hero_subtitle":
      "Notre intervention aux Montel Energy Days sur la croissance du solaire en France, son effet sur les prix capturés et les revenus qu'elle ouvre aux batteries.",
    "montel.mix_eyebrow": "Le mix français",
    "montel.mix_p1":
      'Les parcs solaire et éolien français ont doublé depuis 2020. Les trajectoires PPE3 prolongent cette hausse jusqu\'en 2035 : 55 à 80 GW de solaire, 35 à 40 GW d\'éolien terrestre et environ 15 GW d\'éolien en mer, <span class="accent">le solaire représentant plus de la moitié des capacités ajoutées</span>.',
    "montel.mix_p2":
      "Avec davantage de solaire, une part croissante de la production arrive aux mêmes heures. Elle se concentre autour de midi et fait baisser le prix capturé par les centrales solaires.",
    "montel.capture_eyebrow": "Prix capturés et spreads",
    "montel.capture_p1":
      "Depuis 2023, le prix capturé par le solaire <span class=\"accent\">décroche nettement du prix moyen</span>, avec des creux autour de 50 % sur plusieurs mois récents.",
    "montel.capture_p2":
      "Dans le même temps, l'écart entre les heures les plus chères et les moins chères de la journée s'est fortement accru, surtout au printemps et en été depuis 2024. Ces écarts augmentent directement la valeur d'un actif capable de déplacer l'énergie des heures creuses vers les heures chères.",
    "montel.value_eyebrow": "Où le BESS crée de la valeur",
    "montel.value_li1":
      "<strong>Décalage temporel.</strong> La batterie charge autour de midi, quand le solaire est abondant et les prix bas, puis restitue l'énergie le matin et le soir, ce qui améliore le prix moyen capturé par l'ensemble PV + BESS.",
    "montel.value_li2":
      "<strong>Portefeuille.</strong> Les écarts de prévision des actifs renouvelables se compensent en partie. La batterie couvre le déséquilibre résiduel, même sans colocalisation.",
    "montel.value_li3":
      "<strong>Colocalisation.</strong> PV et BESS partagent le raccordement, l'énergie soutirée directement du PV ne paie pas le TURPE, et la batterie peut absorber la production que le raccordement limiterait.",
    "montel.sizing_eyebrow": "Valoriser et dimensionner une batterie",
    "montel.sizing_p1":
      "Les revenus découlent d'un dispatch simulé sur le Day-Ahead, l'Intraday, les réserves et l'équilibrage, avec un état de charge partagé. La puissance engagée sur un marché n'est plus disponible ailleurs.",
    "montel.sizing_p2":
      "Dans notre cas d'une batterie de 10 MW / 40 MWh colocalisée avec 10 MWpAC de PV, la capacité aFRR représente une part importante du revenue stack des premières années. Avec la croissance du parc BESS, les marchés de réserve saturent à partir des années 2030 et la valeur se déplace vers <span class=\"accent\">l'intraday et l'équilibrage</span>.",
    "montel.sizing_p3":
      "Chaque heure de stockage supplémentaire ajoute du revenu et du coût. Les premières heures captent les meilleures opportunités, puis les revenus marginaux diminuent. La durée optimale est celle qui maximise la valeur nette.",
    "montel.gate_title": "Télécharger la présentation",
    "montel.gate_text":
      "La présentation complète (12 slides, en français) couvre la trajectoire des capacités en France, les prix capturés et les spreads, la complémentarité PV + BESS, la valeur en portefeuille et en colocalisation, et notre méthode d'estimation et de dimensionnement des revenus d'une batterie.",
    "montel.gate_button":
      "Télécharger la présentation (PDF)",
    "montel.chart1_title":
      "Capture PV et spreads intrajournaliers",
    "montel.chart1_source":
      "Source : ENTSO-E",
    "montel.chart2_title":
      "Illustration des profils caractéristiques du PV et d'une BESS",
    "montel.modal_eyebrow":
      "TÉLÉCHARGER LA PRÉSENTATION",
    "montel.modal_title":
      "Du volume à la valeur",
    "montel.modal_text":
      "Saisissez votre adresse mail professionnelle pour télécharger la présentation des Montel Energy Days.",
    "montel.modal_placeholder":
      "email@entreprise.com",
    "montel.modal_submit": "Télécharger le PDF",
    "montel.modal_consent":
      "J'accepte d'accéder à la présentation et de recevoir des informations et publications de Forsyt Energy. Je peux me désabonner à tout moment. <a href=\"../privacy.html\" target=\"_blank\" rel=\"noopener\" style=\"color: var(--brand); text-decoration: none\">Politique de confidentialité</a>.",
    "montel.rel1_eyebrow": "Étude de cas",
    "montel.rel1_title": "Colocalisation PV + BESS : des discours aux données",
    "montel.rel1_text":
      "Dimensionner une batterie pour une centrale PV existante de 9 MWc en France, entre intensité capitalistique et captation des revenus.",
    "montel.rel2_eyebrow": "Réglementation",
    "montel.rel2_title":
      "Ce que change le relèvement du seuil de raccordement HTA pour le PV + BESS",
    "montel.rel2_text":
      "Relever le plafond HTA élargit le champ des projets hybrides qui évitent un raccordement au réseau de transport, et change la façon de dimensionner le raccordement.",
    "montel.rel_link": "Lire l'analyse complète →",
    "montel.view_all": "Voir toutes les analyses",
    "montel.cta_eyebrow": "RESTONS EN CONTACT",
    "montel.cta_text":
      "Vous souhaitez discuter de ces résultats pour votre projet PV, BESS ou hybride ?",
    "montel.cta_btn": "Prendre rendez-vous",
    "montel.cta_note":
      'Ou écrivez-nous à <a href="mailto:contact@forsytenergy.com">contact@forsytenergy.com</a>, nous reviendrons vers vous.',
  },
  de: {
    "montel.hero_eyebrow": "Veranstaltung",
    "montel.hero_title":
      "Vom Volumen zum Wert: Ausbau der Erneuerbaren, erzielte Preise und Chancen für BESS",
    "montel.hero_date":
      'Veröffentlicht am <time datetime="2026-10-01">1. Oktober 2026</time>',
    "montel.hero_subtitle":
      "Unser Vortrag auf den Montel Energy Days über den Solarausbau in Frankreich, seine Wirkung auf die erzielten Preise und die Erlöse, die er Batteriespeichern eröffnet.",
    "montel.mix_eyebrow": "Der französische Strommix",
    "montel.mix_p1":
      "Die installierte Leistung von Solar und Wind in Frankreich hat sich seit 2020 verdoppelt. Die Pfade der PPE3 setzen dieses Wachstum bis 2035 fort: 55 bis 80 GW Photovoltaik, 35 bis 40 GW Wind an Land und rund 15 GW Offshore Wind, wobei <span class=\"accent\">Solar mehr als die Hälfte des Zubaus ausmacht</span>.",
    "montel.mix_p2":
      "Mit mehr Solar fällt mehr Erzeugung in dieselben Stunden. Sie konzentriert sich um die Mittagszeit und senkt den Preis, den Solaranlagen erzielen.",
    "montel.capture_eyebrow":
      "Erzielte Preise und Spreads",
    "montel.capture_p1":
      "Seit 2023 liegt der von Solar erzielte Preis <span class=\"accent\">deutlich unter dem Durchschnittspreis</span>, in mehreren der letzten Monate bei rund der Hälfte.",
    "montel.capture_p2":
      "Im selben Zeitraum ist der Abstand zwischen den teuersten und den günstigsten Stunden des Tages stark gewachsen, vor allem im Frühjahr und Sommer seit 2024. Diese Spreads erhöhen direkt den Wert einer Anlage, die Energie aus günstigen in teure Stunden verschieben kann.",
    "montel.value_eyebrow": "Wo BESS Wert schaffen",
    "montel.value_li1":
      "<strong>Zeitliche Verschiebung.</strong> Die Batterie lädt um die Mittagszeit, wenn Solarstrom reichlich und günstig ist, und entlädt morgens und abends. Das hebt den Durchschnittspreis, den PV + BESS gemeinsam erzielen.",
    "montel.value_li2":
      "<strong>Portfolio.</strong> Prognoseabweichungen erneuerbarer Anlagen gleichen sich teilweise aus. Eine Batterie deckt das verbleibende Ungleichgewicht ab, auch an einem anderen Standort.",
    "montel.value_li3":
      "<strong>Gemeinsamer Standort.</strong> PV und BESS teilen sich den Netzanschluss, direkt aus der PV geladene Energie zahlt keine Netzentgelte nach TURPE, und die Batterie kann Erzeugung aufnehmen, die der Anschluss sonst begrenzen würde.",
    "montel.sizing_eyebrow": "Bewertung und Dimensionierung einer Batterie",
    "montel.sizing_p1":
      "Die Erlöse ergeben sich aus einem simulierten Dispatch über Day-Ahead, Intraday, Regelreserve und Ausgleichsenergie mit einem gemeinsamen Ladezustand. Leistung, die in einem Markt gebunden ist, steht anderswo nicht mehr zur Verfügung.",
    "montel.sizing_p2":
      "In unserem Fall einer Batterie mit 10 MW / 40 MWh am selben Standort wie 10 MWpAC PV macht die Kapazität für aFRR in den ersten Jahren einen großen Teil der Erlöse aus. Mit dem wachsenden Bestand an Batteriespeichern sättigen sich die Reservemärkte ab den 2030er Jahren, und der Wert verlagert sich zu <span class=\"accent\">Intraday und Ausgleichsenergie</span>.",
    "montel.sizing_p3":
      "Jede zusätzliche Speicherstunde bringt Erlöse und Kosten. Die ersten Stunden nutzen die besten Gelegenheiten, danach sinken die Grenzerlöse. Die optimale Dauer ist die, die den Nettowert maximiert.",
    "montel.gate_title": "Präsentation herunterladen",
    "montel.gate_text":
      "Die vollständige Präsentation (12 Folien, auf Französisch) behandelt den Pfad der installierten Leistung in Frankreich, erzielte Preise und Spreads, das Zusammenspiel von PV und BESS, den Wert im Portfolio und am gemeinsamen Standort sowie unsere Methode zur Schätzung und Dimensionierung von Batterieerlösen.",
    "montel.gate_button":
      "Präsentation herunterladen (PDF)",
    "montel.chart1_title":
      "Capture PV und Intraday Spreads",
    "montel.chart1_source":
      "Quelle: ENTSO-E",
    "montel.chart2_title":
      "Illustration typischer Profile von PV und BESS",
    "montel.modal_eyebrow":
      "PRÄSENTATION HERUNTERLADEN",
    "montel.modal_title":
      "Vom Volumen zum Wert",
    "montel.modal_text":
      "Geben Sie Ihre geschäftliche Mailadresse ein, um die Präsentation der Montel Energy Days herunterzuladen.",
    "montel.modal_placeholder":
      "email@unternehmen.com",
    "montel.modal_submit": "PDF herunterladen",
    "montel.modal_consent":
      "Ich bin damit einverstanden, auf die Präsentation zuzugreifen und gelegentlich Neuigkeiten und Veröffentlichungen von Forsyt Energy zu erhalten. Ich kann mich jederzeit abmelden. <a href=\"../privacy.html\" target=\"_blank\" rel=\"noopener\" style=\"color: var(--brand); text-decoration: none\">Datenschutzerklärung</a>.",
    "montel.rel1_eyebrow": "Fallstudie",
    "montel.rel1_title":
      "Co-Location von PV + BESS: vom Diskurs zu Daten",
    "montel.rel1_text":
      "Dimensionierung einer Batterie für eine bestehende Photovoltaikanlage mit 9 MWp in Frankreich, zwischen Kapitalintensität und Erlösen.",
    "montel.rel2_eyebrow": "Regulierung",
    "montel.rel2_title":
      "Was die höhere HTA-Anschlussschwelle für PV + BESS bedeutet",
    "montel.rel2_text":
      "Eine höhere Obergrenze im HTA Netz erweitert den Kreis hybrider Projekte, die ohne Anschluss an das Übertragungsnetz auskommen, und verändert die Dimensionierung des Netzanschlusses.",
    "montel.rel_link": "Vollständige Analyse lesen →",
    "montel.view_all": "Alle Analysen ansehen",
    "montel.cta_eyebrow": "IN KONTAKT BLEIBEN",
    "montel.cta_text":
      "Möchten Sie diese Ergebnisse für Ihr eigenes Projekt mit PV, BESS oder beidem besprechen?",
    "montel.cta_btn": "Termin vereinbaren",
    "montel.cta_note":
      'Oder schreiben Sie an <a href="mailto:contact@forsytenergy.com">contact@forsytenergy.com</a>, wir melden uns bei Ihnen.',
  },
};
